export enum WeatherUnit {
    Ms,
    Kt,
}

export type WindSpeedUnitWire = 'MS' | 'KT'

export const weatherUnitToWire = (unit: WeatherUnit): WindSpeedUnitWire =>
    unit === WeatherUnit.Kt ? 'KT' : 'MS'

export const wireToWeatherUnit = (wire: WindSpeedUnitWire | string | undefined): WeatherUnit =>
    wire === 'KT' ? WeatherUnit.Kt : WeatherUnit.Ms

// `WeatherUnit.Ms` is 0, so `||` here would discard a deliberate m/s pick.
export const resolveWeatherUnit = (
    itemUnit: WeatherUnit | undefined,
    preferredUnit: WeatherUnit,
): WeatherUnit => itemUnit ?? preferredUnit
